export default __webpack_public_path__ + "static/media/6E5EA469-2F6D-4261-AC3E-C4CD992F63CA.958f6514.jpg";